module.exports = __webpack_public_path__ + "img/gw4.d1d6c26e.png";